import _ from 'lodash';

/**
 * Properties on the enrichment data entity which NOT will be included in the
 * copy.
 *
 * @type {Array}
 */
const propsToOmit = [
  'id',
  'referencedIngredientData',
  'modifyDate',
  'luanchDate',
  'lastModifiedBy',
  'createdBy',
  'version',
  'hash',
  'enrichmentStatus',
  'targetPublishDate',
  'targetUnpublishDate',
  'actualPublishedDate',
  'publishBy',
  'isUpToDate'
];

/**
 * Translations on the enrichment data entity which NOT will be included in the
 * copy.
 *
 * @type {Array}
 */
const translationsToOmit = ['versionComment'];

function copyTranslations(forPath, fromLanguage, toLanguages) {
  const translations = _.omit(forPath.info[fromLanguage], translationsToOmit);
  const info = {};
  toLanguages.forEach(toLanguage => {
    info[toLanguage] = translations;
  });
  return info;
}

function copyPrepAndProdSteps(fromEnrichment, fromLanguage, toLanguages) {
  return fromEnrichment.prepAndProdSteps.map(step => {
    const stepDetails = step.stepDetails.map(detail => {
      const info = copyTranslations(detail, fromLanguage, toLanguages);
      return {
        ...detail,
        id: null,
        info
      };
    });
    return {
      ...step,
      id: null,
      key: `id-${Math.round(Math.random() * 1000000)}`,
      stepDetails
    };
  });
}

function copyEnrichmentData(fromEnrichment, fromLanguage, toLanguages) {
  const data = _.omit(fromEnrichment, propsToOmit);
  data.parentPpiEnrichmentDataId = fromEnrichment.id;
  data.info = copyTranslations(data, fromLanguage, toLanguages);
  data.prepAndProdSteps = copyPrepAndProdSteps(
    fromEnrichment,
    fromLanguage,
    toLanguages
  );
  return data;
}

function globalPpiImport(fromPpi, fromEnrichmentId, fromLanguage, toLanguages) {
  let enrichmentData;
  //   if (_.get(fromPpi, 'inProgressPPIEnrichmentData.id') === fromEnrichmentId) {
  //     enrichmentData = fromPpi.inProgressPPIEnrichmentData;
  //   }
  if (_.get(fromPpi, 'publishedPPIEnrichmentData.id') === fromEnrichmentId) {
    enrichmentData = fromPpi.publishedPPIEnrichmentData;
  }
  if (!enrichmentData) {
    throw new Error(
      `Failed to locate PPI Enrichment Data to base PPI on (from enrichment with id: ${fromEnrichmentId})`
    );
  }
  return copyEnrichmentData(enrichmentData, fromLanguage, toLanguages);
}

export default globalPpiImport;
